import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "reactstrap";

import { matchedPhraseCaller, matchedPhraseAgent } from "./Events.module.scss";

const MATCHED_PHRASE_BY_SPEAKER = { caller: matchedPhraseCaller, agent: matchedPhraseAgent };
const MATCHED_PHRASE_PLACEMENT_BY_SPEAKER = { caller: "top", agent: "bottom" };

const MatchedPhraseEvent = ({ startTime, endTime, searchPhrase, speaker, position, progressPercent }) => {
  const tooltipRef = useRef();
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const matchedPhrasePositionMatches = position >= startTime && position <= endTime;
  const toggle = () => {
    // Don't set the toggle value when it's already opened (because of the position) to
    // prevent bugs where the tooltip won't disappear.
    if (!matchedPhrasePositionMatches) {
      setTooltipOpen(!tooltipOpen);
    }
  };

  return (
    <React.Fragment>
      <div ref={tooltipRef} className={MATCHED_PHRASE_BY_SPEAKER[speaker]} style={{ left: `${progressPercent(startTime)}%` }} />
      <Tooltip placement={MATCHED_PHRASE_PLACEMENT_BY_SPEAKER[speaker]} target={tooltipRef}
        trigger="hover" toggle={toggle} isOpen={!!tooltipRef.current && (tooltipOpen || matchedPhrasePositionMatches)}>
        {searchPhrase}
      </Tooltip>
    </React.Fragment>
  );
};

MatchedPhraseEvent.propTypes = {
  startTime: PropTypes.number.isRequired,
  endTime: PropTypes.number.isRequired,
  searchPhrase: PropTypes.string.isRequired,
  speaker: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
  progressPercent: PropTypes.func.isRequired
};

export default MatchedPhraseEvent;
